module.exports = __webpack_public_path__ + "img/ot-wxbtrfly_usdc.699da8fc.png";